module.exports = __webpack_public_path__ + "img/xy.2a538196.png";